import { NgModule } from '@angular/core';
import { NgxSliderMobyComponent } from './ngx-slider-moby.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule
  ],
  declarations: [NgxSliderMobyComponent],
  exports: [NgxSliderMobyComponent]
})
export class NgxSliderMobyModule { }
